import React, { useState } from 'react'

import List from '../../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'
import { ROUTE_NAME as IncidentCategoriesRouteName } from '../../../incidentCategories/constants'

import styles from './List.module.css'

const IncidentCategoriesList = () => {
  const [categoryId, setCategoryId] = useState(null)

  const categoryColumns = [
    {
      header: 'Name',
      value: (item) => item.name,
      onClick: (item) => setCategoryId(item.id),
    },
    { header: 'Buffers', value: (item) => item.buffers },
  ]

  const bufferColumns = [
    { header: 'Id', value: (item) => item.id },
    {
      header: 'Category',
      value: (item) => `${item.category.name}`,
      isLink: true,
    },
    { header: 'AI Layer', value: (item) => item.aiLayer.name },
    { header: 'Distance', value: (item) => item.distance },
    { header: 'Unit', value: (item) => item.unit },
  ]

  return (
    <div className={styles.row}>
      <div className={styles.column}>
        <List
          title="Incident Categories"
          routeName={IncidentCategoriesRouteName}
          apiUrl={API_URL}
          columns={categoryColumns}
        />
      </div>
      <div className={styles.column}>
        {categoryId && (
          <List
            title="Buffers"
            routeName={ROUTE_NAME}
            apiUrl={`${API_URL}/byCategory/${categoryId}`}
            columns={bufferColumns}
          />
        )}
      </div>
    </div>
  )
}

export default IncidentCategoriesList
